
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecomcategories/create",
      function () {
        return require("private-next-pages/ecomcategories/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecomcategories/create"])
      });
    }
  